export default __webpack_public_path__ + "static/media/HSM.24a6d11e.png";